module.exports = __webpack_public_path__ + "img/05-3-5无缝对接.e1e3c790.svg";